module.exports = __webpack_public_path__ + "static/media/Scenario4Two.8af60243.jpg";